<mat-dialog-content>
  <app-avatar-setter></app-avatar-setter>
</mat-dialog-content>
<mat-dialog-actions>
  <lib-button mat-dialog-close>Zamknij</lib-button>
</mat-dialog-actions>
